export default {
  fileServerApi: {
    findSupportOptions: '/api/fileServer/config/findSupportOptions',
    findConfigList: '/api/fileServer/config/findConfigList',
    delConfig: '/api/fileServer/config/delConfig',
    saveConfig: '/api/fileServer/config/saveConfig',
    updateConfig: '/api/fileServer/config/updateConfig',
    changeStatus: '/api/fileServer/config/changeStatus',
    convertImageFile: '/api/fileServer/convertImageFile',
    getCatalogTree: '/api/fileServer/catalog/catalogTree',
    addCatalog: '/api/fileServer/catalog/addCatalog',
    updateCatalog: '/api/fileServer/catalog/updateCatalog',
    delCatalog: '/api/fileServer/catalog/delCatalog',
    //根据文件夹名上传
    uploadFile: "/api/fileServer/uploadFile",
    getFile: "/api/fileServer/getFile",
    getFileList: '/api/fileServer/getFileList',
    deletefiles: '/api/fileServer/deletefiles',
    //根据文件夹id上传
    uploadFileHead: '/api/fileServer/uploadFileHead',
    systemOptions: '/api/fileServer/config/systemOptions',
    refreshConfig: '/api/fileServer/config/refreshConfig',
    // 获取有效配置
    activeConfigList: '/api/fileServer/config/activeConfigList',
    getFileVisitedPath: '/api/fileServer/getFileVisitedPath',
    getFileInfo: '/api/fileServer/getFileInfo'
  }
}
